import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  aPIendPointsAll: [],
  aPIendPoints: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const APIendPointsSlice = createSlice({
  name: "aPIendPoints",
  initialState,
  reducers: {
    setaPIendPointsAll: (state, action) => {
      state.aPIendPointsAll = action.payload;
    },
    setaPIendPoints: (state, action) => {
      state.aPIendPoints = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setaPIendPointsAll,
  setaPIendPoints,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = APIendPointsSlice.actions;

export default APIendPointsSlice.reducer;
